export default {
  appSettings: 'App settings',
  userSettings: 'User settings',
  tenantSettings: 'Qmulus settings',
  APIKey: 'API Keys',
  notificationChannel: 'Notification Channels',
  userSubscription: 'User subscriptions',
  channels: 'Channels',
  reportBuilder: 'Report builder',
  assetParameterDefinition: 'Asset parameter definitions',
};
